<app-nav-bar></app-nav-bar>
<div class="container" [ngClass]="{ 'language-arabic': arabicLanguage }">
  <div class="top-heading-abrogation">
    <h4>{{ "Differences" | translate }}</h4>
  </div>
  <div class="dropdown-header">
    <div class="left-side-align">
      <app-soora-dropdown
        [arabicLanguage]="arabicLanguage"
        (passSooraParent)="getSelectedSooraFromChild($event)"
      ></app-soora-dropdown>
      <div class="language-select">
        <app-translation-dropdown
          (passTranslationParent)="changeTranslation($event)"
        ></app-translation-dropdown>
      </div>
    </div>
    <div class="right-side-align">
      <app-share></app-share>
      <span class=""
        ><a href="javascript:void(0);" class="right-side-about">
          {{ "About" | translate }}</a
        ></span
      >
    </div>
  </div>
  <div class="main-dody-abrogation">
    <div class="abrogation-heading">
      <h4
        class=""
        *ngIf="checkObjectEmpty(selectedSoora); else showSelectedSooraPrent"
      >
        {{
          arabicLanguage
            ? selectedSoora.SooraName
            : selectedSoora.ArabicEnglishName
        }}
      </h4>
      <ng-template #showSelectedSooraPrent>
        <h4 class="">{{ "All" | translate }}</h4>
      </ng-template>
    </div>
    <div class="abrogation-content">
      <ng-container *ngIf="differencesList.length > 1">
        <ng-container *ngFor="let difference of differencesList; let i = index">
          <h3
            class=""
            *ngIf="
              difference.SooraId !== differencesList[i - 1]?.SooraId || i === 0
            "
          >
            {{ difference.SooraId }}.
            {{
              arabicLanguage
                ? difference.Soora.SooraName
                : difference.Soora.ArabicEnglishName
            }}
          </h3>
          <div
            class="abrogation-paramain"
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="3000"
            (scrolled)="onScroll()"
          >
            <span class="abrogation-sura-number">
              {{ difference.Verse }}
            </span>
            <P
              [ngClass]="arabicLanguage ? 'pr50' : 'pl50'"
              class="abrogation-paragraph"
            >
              <a
                href="javascript:void(0);"
                [routerLink]="[
                  '/information/difference-detail',
                  difference.SooraId,
                  difference.Verse,
                  translationId
                ]"
                >{{ difference.Narration.Narration }}</a
              >
            </P>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
